import React from "react";
import { PropTypes } from "prop-types";
import { connectWithLifecycle } from "react-lifecycle-component";
import TextField from "material-ui/TextField";
import FlatButton from "material-ui/FlatButton";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import {
  addQuantity,
  saveOrderLine,
  addVariationField /*, fetchOptionsRequest*/
} from "../../redux/modules/ordersDuck";
//import { push } from 'react-router-redux'
import CancelOrderLineButton from "../container/CancelOrderLineButton";
import {
  getCurrentOrderLineMap,
  getProductsMap,
  getCurrentOrderMap,
  getCurrentVariationFieldsMap
} from "../../redux/selectors";
import { List, Map } from "immutable";

const mapStateToProps = state => {
  const storedOrderLine = getCurrentOrderLineMap(state);
  const currentVariationFields = getCurrentVariationFieldsMap(state);
  const currentOrderLine = storedOrderLine.setIn(
    ["variation", "fields"],
    currentVariationFields.merge(storedOrderLine.getIn(["variation", "fields"]))
  );
  const delivered = getCurrentOrderMap(state).get("delivered");
  return {
    currentOrderLine,
    products: getProductsMap(state),
    currentVariationFields: getCurrentVariationFieldsMap(state),
    delivered
  };
};

const mapDispatchToProps = dispatch => ({
  handleQuantityChange: (event, value) => {
    dispatch(addQuantity(value));
  },
  handleSaveOrderLine: orderLine => {
    dispatch(saveOrderLine(orderLine));
  },
  handleVariationTextfieldChange: (name, value) => {
    dispatch(addVariationField(name, value));
  },
  handleVariationSelectChange: (name, value) => {
    dispatch(addVariationField(name, value));
  },
  componentDidMount: () => {}
});

const validate = orderLine => {
  return !orderLine.get("quantity");
};

const getStoredFieldValue = (orderLine, variationField) => {
  const variationDetails = orderLine.get("variationDetails") || new List();
  const detail =
    variationDetails.find(
      detail => detail.get("name") === variationField.get("name")
    ) || new Map();
  return detail;
};

const VariationDetails = props => {
  const {
    currentOrderLine,
    products,
    currentVariationFields,
    handleQuantityChange,
    handleSaveOrderLine,
    handleVariationTextfieldChange,
    handleVariationSelectChange,
    delivered
  } = props;

  const productId = currentOrderLine.getIn(["variation", "product", "id"]);
  const currentOrderLineProduct = products.find(
    product => product.get("id") === productId
  );
  const currentOrderLineVariation = currentOrderLineProduct
    .get("variations")
    .find(
      variation =>
        variation.get("id") === currentOrderLine.getIn(["variation", "id"])
    );

  return (
    <div>
      <h1>Detalles</h1>
      <div>
        Producto: {currentOrderLineProduct.get("name")}
        <br />
        Variación: {currentOrderLineVariation.get("name")}
      </div>
      <TextField
        id="quantity"
        type="number"
        value={currentOrderLine.get("quantity")}
        floatingLabelText="Cantidad"
        disabled={delivered}
        onChange={(event, value) => handleQuantityChange(event, value)}
      />
      <br />
      {currentVariationFields.map(variationField => {
        const field = getStoredFieldValue(currentOrderLine, variationField);
        switch (variationField.get("type")) {
          case "TEXTFIELD":
            return (
              <div key={variationField.get("name")}>
                <TextField
                  type="text"
                  floatingLabelText={variationField.get("name")}
                  value={field.get("value") || ""}
                  hintText={variationField.get("hint")}
                  floatingLabelFixed={variationField.get("hint").length > 0}
                  disabled={delivered}
                  onChange={(event, value) =>
                    handleVariationTextfieldChange(
                      variationField.get("name"),
                      value
                    )}
                />
              </div>
            );

          case "SELECT":
            return (
              <div key={variationField.get("name")}>
                <SelectField
                  floatingLabelText={variationField.get("name")}
                  value={field.get("value")}
                  disabled={delivered}
                  onChange={(event, index, value) =>
                    handleVariationSelectChange(
                      variationField.get("name"),
                      value
                    )}
                >
                  {variationField.get("options").map(option => {
                    return (
                      <MenuItem
                        value={option.get("id")}
                        key={option.get("id")}
                        primaryText={option.get("value")}
                      />
                    );
                  })}
                </SelectField>
              </div>
            );
          default:
            return (
              <span key={variationField.name}> [Elemento por defecto] </span>
            );
        }
      })}
      <br />
      <CancelOrderLineButton />
      {delivered
        ? ""
        : <FlatButton
            label="Confirmar"
            onClick={() => handleSaveOrderLine(currentOrderLine)}
            disabled={validate(currentOrderLine)}
          />}
    </div>
  );
};

VariationDetails.propTypes = {
  handleQuantityChange: PropTypes.func.isRequired,
  handleSaveOrderLine: PropTypes.func.isRequired
};

const VariationDetailsPage = connectWithLifecycle(
  mapStateToProps,
  mapDispatchToProps
)(VariationDetails);

export default VariationDetailsPage;



// WEBPACK FOOTER //
// ./src/components/pages/Selling-Order-Variation-Details.js